var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"icon":"","left":"","color":_vm.avatar.color,"size":"28"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.avatar.uid))])])}
var staticRenderFns = []

export { render, staticRenderFns }